export const MAX_FILES = 3
export const MAX_FILE_SIZE = 5 * 1024 * 1024
export const FILE_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'application/pdf', 'text/plain']

type FileLike = Pick<File, 'name' | 'size' | 'type'>

// Mirrors ContactMessage#attachments_are_acceptable; the server re-checks.
export function fileError(files: FileLike[]): string | null {
  if (files.length > MAX_FILES) return `Attach at most ${MAX_FILES} files.`
  for (const file of files) {
    if (file.size > MAX_FILE_SIZE) return `${file.name} is larger than 5 MB.`
    if (!FILE_TYPES.includes(file.type)) return `${file.name} must be an image, PDF or text file.`
  }
  return null
}

export function formError(data: { email?: string | null; subject: string; subjectOther: string; message: string }): string | null {
  if (data.email !== undefined && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email ?? '')) return 'Enter a valid email.'
  if (!data.subject) return 'Choose a subject.'
  if (data.subject === 'Other' && !data.subjectOther.trim()) return 'Type a subject.'
  if (data.message.trim().length < 10) return 'Write a bit more so we can help (10+ characters).'
  return null
}
